module.exports = __webpack_public_path__ + "img/subtract.a2094556.svg";